/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import Excel from 'exceljs';
import {AssetTemplateOptions} from '../xlsx/AssetTemplate';
import {DeviceTemplateOptions} from '../xlsx/DeviceTemplate';
import {DriverTemplateOptions} from '../xlsx/DriverTemplate';
import {UserTemplateOptions} from '../xlsx/UserTemplate';
import {Account, CTCEntity, Entity} from './entities';

export interface TemplateValidation {
  allowBlank: boolean;
  showErrorMessage: boolean;
  error: string;
  index: number;
  type: string;
  formulae?: (string|number)[];
  operator?: string;
  workbook?: Excel.Workbook;
  options?: TemplateOptions;
  column?: TemplateColumn;
  conditionallyRequired?: boolean;
}
  
// Types of Template filter Operators
export enum TemplateOperators {
  Between = 'between',
  LessThanOrEqual = 'lessThanOrEqual',
  GreaterThanOrEqual = 'greaterThanOrEqual'
}
  
// defines the type definitions for common excel column options pre normalization ...
export type TemplateOptions =
  AssetTemplateOptions |
  UserTemplateOptions |
  DriverTemplateOptions |
  DeviceTemplateOptions;

// defines the extended type definitions for export options post normalization ...
export type ResolvedTemplateOptions = TemplateOptions & {
  titles?: boolean;
  appendDate?: boolean;
  immediate?: boolean;
  formatter?: Function;
  format?: string;
}
  
// Template creation props for each Entities
export interface EntityTemplate {
  entity: Entity;
  columns: TemplateColumn[];
  options: TemplateOptions;
  workbook?: Excel.Workbook;
}
  
export interface TemplateColumns {
  column?: TemplateColumn;
  validation?: TemplateValidation;
  options?: TemplateOptions
}
// Create Entity Template creation props
export interface DownloadTemplate {
  augmenter: Function;
  entity: Entity;
  title: string;
  filename?: string;
  columns: TemplateColumn[];
  options: TemplateOptions;
  rows?: CTCEntity[];
}
  
// Excel template column types
export enum TemplateColumnTypes {
  TextLength = 'textLength',
  List = 'list',
  Text = 'text',
  Date = 'date',
  Whole = 'whole',
  Decimal = 'decimal'
}
  
// Excel template columns
export interface TemplateColumn {
  header: string;
  key?: string;
  field?: string;
  type?: TemplateColumnTypes;
  required?: boolean;
  max?: number;
  min?: number;
  error?: string;
  width?: number;
  style?: object;
  hidden?: boolean;
  conditionallyRequired?: boolean;
}

// Create Entity Template creation props
export interface Template {
  columnEntries: TemplateColumn[];
  columnValidations: TemplateValidation[];
}

// defines the type definitions for Dropsheet options ...
export interface DropsheetOptions {
  target?: HTMLElement,
  maxEntries?: number,
  maxSize?: number,
  format?: string,
  onComplete?: Function,
  onFailed?: Function,
  onSizeError?: Function,
  converter?: Function,
  parse?: boolean,
  isAssetBulk?: boolean,
  convertCSVToJSON?: boolean
}

// Imported Account type definition...
export interface ImportAccount extends Account {
  assetCategories?: string,
  operatorCategories?: string,
  routeCategories?: string,
  landmarkCategories?: string,
  overspeedThreshold?: number,
  workStopDuration?: number,
}
